export const trackMatomoPageView = (path: string) => {
    if (window._paq) {
        const fullUrl = window.location.origin + path;
        window._paq.push(["setCustomUrl", fullUrl]);
        window._paq.push(["trackPageView"]);
    }
};

export const trackMatomoEvent = (
    category: string,
    action: string,
    name: string = "",
    value: string | number = ""
    ) => {
        if (window._paq) {
            window._paq.push(["trackEvent", category, action, name, value]);
        }
};

// --------------------
// GOOGLE ANALYTICS (GA4)
// --------------------
export const trackGA4PageView = (path: string) => {
    if (typeof window.gtag !== "undefined") {
        window.gtag("event", "page_view", {
        page_location: window.location.origin + path,
        page_path: path,
        page_title: document.title,
        });
    }
};

export const trackGA4Event = (
    name: string,
    params: Record<string, any> = {}
    ) => {
    if (typeof window.gtag !== "undefined") {
        window.gtag("event", name, params);
    }
};

// --------------------
// GLOBAL TRACKING
// --------------------
export const trackPageView = (path: string) => {
    trackMatomoPageView(path);
    trackGA4PageView(path);
};

export const trackEvent = (
    category: string,
    action: string,
    name = "",
    value: string | number = ""
) => {
    trackMatomoEvent(category, action, name, value);
    trackGA4Event(action, { category, name, value });
};